import type { ThemeConfig } from "antd";

export const antTheme: ThemeConfig = {
  token: {
    colorPrimary: "#0A96CC",
    colorTextSecondary: "#FF6B35",
    colorSuccess: "#40B554",
    colorWarning: "#C67904",
    colorError: "#ef4444",
    colorInfo: "#00AFEF",
    borderRadius: 4,
    fontFamily: '"Raleway", sans-serif',
    fontSize: 12,
  },
  components: {
    Form: {
      itemMarginBottom: 6,
      verticalLabelPadding: 1,
      labelFontSize: 13,
    },
    Input: {
      activeBg: "inherit",
    },
    Tabs: {
      itemSelectedColor: "#40B554",
      itemHoverColor: "#40B554",
      inkBarColor: "#40B554",
    },
  },
};
